import { HeadCell } from 'components/gifts-table/TableList';
import CurrencyFormat from 'react-currency-format';

export default function PriceCell(props) {
  const { price = 0, totalPrice = null, realPrice = null, isBody, align = 'center', width = '' } = props;

  return (
    <>
      { price !== null ? isBody ? (
        <td className={`text-${align}`} style={{ verticalAlign: 'middle' }} width={width || ''}>
          {realPrice && (
            <CurrencyFormat
              value={realPrice}
              displayType="text"
              thousandSeparator
              prefix="$"
              renderText={(formattedPrice) => (
                <del className="precio">{formattedPrice}</del>
              )}
            />
          )}
          
          {totalPrice 
            ? <CurrencyFormat
              value={totalPrice}
              displayType="text"
              thousandSeparator
              prefix="$"
              renderText={(formattedPrice) => (
                <>{formattedPrice}</>
              )}
            />
            : <CurrencyFormat
              value={price}
              displayType="text"
              thousandSeparator
              prefix="$"
              renderText={(formattedPrice) => (
                <>{formattedPrice}</>
              )}
            />
          }
         
        </td>
      ) : (
        <HeadCell column={props} />
      ) : <h2 className={`text-${align}`}>-</h2> }
    </>
  );
}
